import { render, staticRenderFns } from "./AddTaxWindow.vue?vue&type=template&id=3ecdcbda&scoped=true&"
import script from "./AddTaxWindow.vue?vue&type=script&lang=js&"
export * from "./AddTaxWindow.vue?vue&type=script&lang=js&"
import style0 from "./AddTaxWindow.vue?vue&type=style&index=0&id=3ecdcbda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecdcbda",
  null
  
)

export default component.exports